var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---IT-Shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ITShop---Computers---Listing---Table-view",
    transform: "translate(-508.000000, -674.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "m/listing/table-computers/Normal-state",
    transform: "translate(472.000000, 643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/24/connect-amber",
    transform: "translate(36.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 11.25
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "18.0582109 14 6 14 10.2066605 18.2066605"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(12.029105, 8.103330) rotate(-180.000000) translate(-12.029105, -8.103330) ",
    points: "18.0582109 6 6 6 10.2066605 10.2066605"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectSwitch);
export default __webpack_public_path__ + "static/media/connect-switch.b9c8cb9da49d6b6b439cb7e390817d4a.svg";
export { ForwardRef as ReactComponent };